export default "__VITE_ASSET__DKbQ7c9n__"